import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import PaymentMethodService from '../services/PaymentMethodService';
import { loadingPaymentMethodDropdown } from '../store/slices/paymentMethods/paymentMethodSlice';

export const usePaymentMethod = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paymentMethodDropdown } = useSelector(
    (state: RootState) => state.paymentMethod
  );

  const fetchPaymentMethodDropdown = async () => {
    try {
      const response = await PaymentMethodService.fetchDropdown();
      dispatch(loadingPaymentMethodDropdown(response));
    } catch (error) {
      console.error("Error al cargar payment methods:", error);
    }
  };

  return {
    paymentMethodDropdown,
    fetchPaymentMethodDropdown,
  };
};
